import { Tab, Tabs, useTheme } from "@mui/material";
import { useIsDarkMode } from "web_myplann/Shared/Renderer/useIsDarkMode";

interface MyPlannTabProps {
	value: number;
	onChange: (event: React.SyntheticEvent, newValue: number) => void;
	tabs: { id: string; label: string }[];
}

function a11yProps(index: number) {
	return {
		id: `portfolio-tab-${index}`,
		"aria-controls": `portfolio-tabpanel-${index}`,
	};
}

export const MyPlannTabs: React.FC<MyPlannTabProps> = ({
	value,
	onChange,
	tabs,
}) => {
	const theme = useTheme();
	const isDarkMode = useIsDarkMode();

	return (
		<Tabs
			value={value}
			onChange={onChange}
			variant="fullWidth"
			sx={{
				width: "100%",
				paddingInline: 1.6,
				minHeight: 32,
				"& .MuiTabs-indicator": { display: "none" },
				"& .MuiTab-root": {
					minHeight: 32,
					height: 32,
					paddingTop: "16px",
					paddingBottom: "16px",
					fontSize: 14,
					fontWeight: 400,
					border: theme.colors.border.solid(theme.palette.deprecated.grey[200]),
					"&:not(:last-of-type)": { borderRight: 0 },
					"&:first-of-type": { borderRadius: "12px 0 0 12px" },
					"&:last-of-type": { borderRadius: "0 12px 12px 0" },
					backgroundColor: theme.palette.common.white,
					textTransform: "none",
					color: isDarkMode
						? theme.palette.deprecated.grey[300]
						: theme.palette.deprecated.grey[500],
					"&.Mui-selected": {
						backgroundColor: theme.palette.primary.main,
						color: isDarkMode
							? theme.palette.common.black
							: theme.palette.common.white,
					},
				},
				paddingBottom: "8px",
			}}
		>
			{tabs.map((tab, index) => (
				<Tab key={tab.id} label={tab.label} {...a11yProps(index)} />
			))}
		</Tabs>
	);
};
